/** Gift purchases route through /payment with these plan_id sentinels
 *  (0 = gift card, 4 = gift subscription) and use separate backend endpoints.
 *  They stay on the v1 checkout for this ticket. */
export function isGiftPlanId(planId: string): boolean {
  return planId === "0" || planId === "4";
}
